import type { Namespace, TFunction } from 'i18next'
import type { z } from 'zod'
import type {
  BaseIssueCode,
  BaseValidationRule,
  CustomValidationRule,
  TypedBaseZodIssue,
  TypedZodCustomIssue,
  ValidationRule,
} from './types.ts'

export function createErrorMapRule<
  TCode extends BaseIssueCode,
  TNamespace extends Namespace,
>(
  issueCode: TCode,
  t: TFunction<TNamespace>,
  rule: BaseValidationRule<TCode, TNamespace>
) {
  return ((issue: TypedBaseZodIssue<TCode>, ctx: z.ErrorMapCtx) => {
    if (issue.code === issueCode) {
      return rule(issue, ctx, t)
    }

    return null
  }) as ValidationRule
}

export function createCustomErrorMapRule<TCode extends Record<string, unknown>>(
  rule: CustomValidationRule<TCode>
) {
  return ((issue: TypedZodCustomIssue<TCode>, ctx: z.ErrorMapCtx) => {
    if (issue.code === 'custom') {
      return rule(issue, ctx)
    }

    return null
  }) as ValidationRule
}
